import { useState } from 'react';
import { supabase } from '../lib/supabase.js';
import { useAuth } from '../lib/auth.js';
import { formatMemberNumber } from '../lib/member.js';

// Admin-only panel for creating new member accounts. Renders nothing
// unless the signed-in user has profile.is_admin = true.
export default function AdminInvite() {
  const { profile } = useAuth();
  const [open, setOpen]               = useState(false);
  const [email, setEmail]             = useState('');
  const [password, setPassword]       = useState('');
  const [displayName, setDisplayName] = useState('');
  const [slug, setSlug]               = useState('');
  const [memberNumber, setMemberNumber] = useState('');
  const [isAdmin, setIsAdmin]         = useState(false);
  const [busy, setBusy]               = useState(false);
  const [msg, setMsg]                 = useState('');
  const [err, setErr]                 = useState('');

  if (!profile?.is_admin) return null;

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true); setErr(''); setMsg('');
    try {
      const session = await supabase.auth.getSession();
      const callerToken = session.data.session?.access_token;
      const res = await fetch('/.netlify/functions/invite-member', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim(),
          password,
          displayName: displayName.trim(),
          slug: slug.trim().toLowerCase(),
          isAdmin,
          memberNumber: memberNumber || undefined,
          callerToken,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Invite failed.');
      setMsg(`✓ Member ${formatMemberNumber(data.profile.member_number)} ${data.profile.display_name} created. Send them their email + password.`);
      setEmail(''); setPassword(''); setDisplayName(''); setSlug(''); setMemberNumber(''); setIsAdmin(false);
    } catch (e) {
      setErr(e.message || 'Failed.');
    } finally {
      setBusy(false);
    }
  }

  if (!open) {
    return (
      <button
        type="button"
        className="hb-chip"
        onClick={() => setOpen(true)}
        style={{ background: '#fff' }}
      >
        + Invite a member
      </button>
    );
  }

  return (
    <div className="hb-admin">
      <div className="hb-admin__header">
        <h3>Issue a new membership card</h3>
        <button type="button" className="hb-chip" onClick={() => setOpen(false)}>Close</button>
      </div>
      <form onSubmit={onSubmit} className="hb-admin__form">
        <label>
          Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="serina@example.com" />
        </label>
        <label>
          Temporary password
          <input type="text" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="at least 6 chars" />
        </label>
        <label>
          Display name
          <input type="text" required value={displayName} onChange={(e) => setDisplayName(e.target.value)} placeholder="Serina" />
        </label>
        <label>
          URL slug
          <input type="text" required value={slug} onChange={(e) => setSlug(e.target.value)} placeholder="serina" pattern="^[a-z0-9][a-z0-9-]{0,30}[a-z0-9]$" />
        </label>
        <label>
          Member # (optional — auto-assigned if blank)
          <input type="number" min="1" value={memberNumber} onChange={(e) => setMemberNumber(e.target.value)} placeholder="1" />
        </label>
        <label className="hb-admin__check">
          <input type="checkbox" checked={isAdmin} onChange={(e) => setIsAdmin(e.target.checked)} />
          Grant admin privileges
        </label>
        {err && <div className="hb-signin__err">{err}</div>}
        {msg && <div className="hb-admin__ok">{msg}</div>}
        <button type="submit" disabled={busy} className="hb-signin__btn">
          {busy ? 'Issuing card…' : 'Issue membership card'}
        </button>
      </form>
    </div>
  );
}
